import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import { Link } from 'react-router-dom';
import logo from '../common/app2soft/images/logo_color_140X40.png';

import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css'; 

import imgHanko from "../common/app2soft/images/hanko.jpg";
import imgThomas from "../common/app2soft/images/thomas.jpg"

import Header from '../header';
import Footer from '../footer';
import './style.scss';

class Homepage extends Component{
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        }
        AOS.init();
    }
    componentWillMount(){
        let cache = localStorage.isFirst;
        if(cache !== "true"){
            setTimeout( ()=> {
                this.setState({ loaded: true });
            }, 3000);
            localStorage.setItem('isFirst', "true");
        }else{
            this.setState({ loaded: true });
        }
    }
    render(){
        let content = null;

        const loader = (
            <div className="loader-page"><h2 data-aos="fade-down">Welcome to App2Soft</h2></div>
        )

        const template = (
            <div className="page">
                <Header key="home" animation={false} page="homepage"/>
                <div className="container">
                    <div className="item-1" data-aos="fade-left">

                    <iframe frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="100%" height="100%" src="https://www.youtube.com/embed/kGpQrw1oCow?autoplay=1&amp;enablejsapi=1&amp;origin=http%3A%2F%2Fapp2soft.com&amp;widgetid=1" id="widget2"></iframe>
                        <h2 data-aos="fade-right">We are <b>App2soft</b>, the best nearshore software development partner you can get</h2>
                    </div>
                    <div className="item-2" data-aos="fade-up">
                        <div className="inner">
                            <h2>Front End Development</h2>
                            <Link to='/services/front-end' data-aos="fade-up">See More</Link>
                        </div>
                    </div>
                    <div className="item-3" data-aos="fade-up">
                        <div className="inner">
                            <h2>Back End Development</h2>
                            <Link to="/services/back-end" data-aos="fade-up">See More</Link>            
                        </div>
                    </div>
                    <div className="item-4" data-aos="fade-up">
                        <div className="inner">
                            <h2>Mobile Development</h2>
                            <Link to='/services/mobile' data-aos="fade-up">See More</Link>
                        </div>
                    </div>
                    <div className="item-5" data-aos="fade-up">
                        <div className="inner">    
                            <h2>Microsoft Development</h2>
                            <Link to='/services/microsoft' data-aos="fade-up">See More</Link>
                        </div>
                    </div>
                    <div className="item-6" data-aos="fade-up">
                        <div className="inner">
                            <h2>Database Development</h2>
                            <Link to='/services/database' data-aos="fade-up">See More</Link>
                        </div>
                    </div>
                    <div className="item-7" data-aos="fade-up">
                        <iframe width="100%" height="250" src="https://www.youtube.com/embed/TzxmjbL-i4Y"></iframe>
                    </div>
                    <div className="item-8" data-aos="fade-up">
                        <div className="inner">    
                            <h2>UI / UX Development</h2>
                            <Link to='/services/ui-ux' data-aos="fade-up">See More</Link>
                        </div>
                    </div>
                    <div className="item-9" data-aos="fade-up">
                        <div className="inner"> 
                            <h2>DevOps Development</h2>
                            <Link to='/services/devops' data-aos="fade-up">See More</Link>
                        </div>
                    </div>
                    <div className="item-10" data-aos="fade-up">
                        <div>
                            <div>
                                <h2>Custom Software Development Firm</h2>
                                <p>We guarantee you that we will be the most trustworthy and transparent nearshore software development company you could ever work with.</p>
                            </div>
                        </div>
                    </div>
                    <div className="item-11" data-aos="fade-up">
                        <div>
                            <h2>Nearshore Office</h2>
                        </div>
                    </div>
                    <div className="item-12" data-aos="fade-up">
                        <div>
                            <h2>Most Trustworthy</h2>
                        </div>
                    </div>
                    <div className="item-13" data-aos="fade-up">
                        <div>
                            <div>
                                <h2>Develop Custom Software</h2>
                                <p>Let us put together the best development team you can get around with the option of having your own international nearshore office by extending your company’s borders.</p>
                            </div>            
                        </div>
                    </div>
                    <div className="item-14" data-aos="fade-up">
                        <div>
                            <div>
                                <h2>Agile Software Development</h2>
                                <p>Combining the outstanding skill sets of the best developers in town and with an agile development method you will have the high-quality fast paced development that you need.</p>
                            </div>           
                        </div>
                    </div>
                    <div className="item-15" data-aos="fade-up">
                        <iframe width="100%" height="500" src="https://www.youtube.com/embed/_I94-tJlovg"></iframe>
                    </div>
                    <div className="item-16" data-aos="fade-up">
                        <iframe width="100%" height="500" src="https://www.youtube.com/embed/hDJdkcdG1iA"></iframe>
                    </div>
                    <div className="item-17" data-aos="fade-up">
                        <iframe width="100%" height="250" src="https://www.youtube.com/embed/_I94-tJlovg"></iframe>
                    </div>
                    <div className="item-18" data-aos="fade-up">
                        <div>
                            <h2>Build Your Team</h2>
                        </div>
                    </div>
                    <div className="item-19" data-aos="fade-up">
                        <iframe width="100%" height="250" src="https://www.youtube.com/embed/Z9QbYZh1YXY"></iframe>
                    </div>
                    <div className="item-20" data-aos="fade-up">
                        <div>
                            <h2>Best Developer</h2>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )

        if ( this.state.loaded ){
            content = template;
        }else{
            content = loader;
        }

        return(
            <div>
                <MetaTags>
                    <title>App2soft | Custom Software Development Firm</title>
                    <meta name="description" content="Develop custom software becomes better than ever by using an agile software development methodology by a recognized custom software development firm on the job." />
                    <meta name="keywords" content="Custom Software Development Firm, Develop Custom Software, Agile Software Development"/>
                    <meta name="author" content="Upway Solutions" />
                    <meta property="og:image" content={`${logo}`} />
                </MetaTags>
                {content}
            </div>
        )
    }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/homepage2/index.js